import { getHeaders } from '../../../core/api';
import { host } from '../../../config';

export function fetchBookings(page, searchTerm, statusSelected, startDateSelected, endDateSelected) {
  const limit = 30
  const offset = page * 30
  return fetch(`${host}/api/booking/bookingrequest/?limit=${limit}&offset=${offset}&searchTerm=${searchTerm}&statusSelected=${statusSelected}&startDateSelected=${startDateSelected}&endDateSelected=${endDateSelected}`, {
    headers: getHeaders(),
    method: 'GET',
  });
}
export function fetchBooking(id) {
  return fetch(`${host}/api/booking/request/${id}/`, {
    headers: getHeaders(),
    method: 'GET',
  });
}

export function addNotes(id,payload){
  return fetch(`${host}/api/booking/request/${id}/addNotes/`,{
    headers: getHeaders(),
    method: 'POST',
    body: JSON.stringify(payload),
  })
}

export function changeStatus(id,payload){
  return fetch(`${host}/api/booking/request/${id}/changeStatus/`,{
    headers: getHeaders(),
    method: 'POST',
    body: JSON.stringify(payload),
  })
}

export function getBrandNote(id,payload){
  return fetch(`${host}/api/booking/request/${id}/getBrandNotes/`,{
    headers: getHeaders(),
    method: 'POST',
    body: JSON.stringify(payload),
  })
}

export function fetchBids() {
  return fetch(`${host}/api/booking/bid/`, {
    headers: getHeaders(),
    method: 'GET',
  });
}
export function patchBid(bidId, payload) {
  return fetch(`${host}/api/booking/bid/${bidId}/`, {
    headers: getHeaders(),
    method: 'PATCH',
    body: JSON.stringify(payload),
  });
}

export function postBidDetailsRate(payload) {
  return fetch(`${host}/api/bid/save_biddetails_rate/`, {
    headers: getHeaders(),
    method: 'POST',
    body: JSON.stringify(payload),
  });
}

export function fetchSendBookingBid(bidId, payload) {
  return fetch(`${host}/api/booking/bid/${bidId}/send/`, {
    headers: getHeaders(),
    method: 'POST',
    body: JSON.stringify(payload),
  });
}

export function updateContact(bidId, payload) {
  return fetch(`${host}/api/booking/bid/${bidId}/update_contact/`, {
    headers: getHeaders(),
    method: 'POST',
    body: JSON.stringify(payload),
  });
}

export function deleteContact(bidId, payload) {
  return fetch(`${host}/api/booking/bid/${bidId}/delete_contact/`, {
    headers: getHeaders(),
    method: 'POST',
    body: JSON.stringify(payload),
  });
}

export function updatePinUnpinStatus(id, payload) {
  return fetch(`${host}/api/booking/bookingrequest/${id}/update_pin_state/`, {
    headers: getHeaders(),
    method: 'POST',
    body: JSON.stringify(payload),
  });
}

export function patchTourStatus(id,payload) {
  const saveUrl = `${host}/api/booking/bookingrequest/${id}/changeTourStatus/`;
  return fetch(saveUrl, {
    headers: getHeaders(),
    method: 'POST',
    body: JSON.stringify(payload),
  });
}

export function getTourStatusData() {
  const saveUrl = `${host}/api/booking/getTourViewSet/`;
  return fetch(saveUrl, {
    headers: getHeaders(),
    method: 'GET',
  });
}


// WEBPACK FOOTER //
// src/routes/booking/modules/api.js